import {useStyles} from "../miscellaneous/constants";
import Drawer from "@material-ui/core/Drawer";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Divider from "@material-ui/core/Divider";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ListItemText from "@material-ui/core/ListItemText";
import React from "react";
import Filters from "./Filters"
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import {Looks3, LooksOne, LooksTwo} from "@material-ui/icons";

export default function LateralBar(props) {
    const classes = useStyles();

    async function handleAll(e) {
        for (let i = 0; i < props.solvers.length; i++)
            await props.solversSelectionUpdate(e, props.solvers[i].id)
    }

    let ranks = [<LooksOne/>, <LooksTwo/>, <Looks3/>]
    return (
        <Drawer variant="persistent" classes={{paper: clsx(classes.drawerPaper)}} open={props.displayLateralBar}>
            <div className={classes.toolbarIcon}>
                <IconButton>
                    <ChevronLeftIcon/>
                </IconButton>
            </div>
            <Divider/>
            <div style={{'paddingLeft': '10px'}}><List>
                <Filters selection={props.selection} setSelection={props.setSelection} filters={props.filters}
                         setFilters={props.setFilters} constraints = {props.constraints} families={props.families}
                         nofilters={props.nofilters}/>
                <Divider/>
                <br/>
                <ListSubheader inset style={{color:'#408033'}}><big><big>Solvers</big></big></ListSubheader>
                <ListItem key='all'style={{display: "flex", justifyContent: "center"}}>
                    <ButtonGroup color='primary' >
                        <Button size='small'  disabled={props.selectedSolvers.length===0} variant='contained' color='primary' onClick={e => props.solversSelectionUpdate(e, [])}>None</Button>
                        <Button size='small'  disabled={props.selectedSolvers.length===props.solvers.length} variant='contained' color='primary' onClick={e => props.solversSelectionUpdate(e, props.solvers.map(s => s.id))}>All</Button>
                    </ButtonGroup>
                </ListItem>
                {props.solvers.map(s =>
                    <ListItem key={"solver" + s.id} buttonle
                              selected={props.selectedSolvers.filter(s2 => s2.id === s.id).length !== 0}
                              onClick={e => props.solversSelectionUpdate(e, [s.id])}>
                        <ListItemIcon>
                            {props.rank != null && props.rank.indexOf(s.id) !== -1 ? ranks[props.rank.indexOf(s.id)] :
                                <DashboardIcon/>}
                        </ListItemIcon>
                        <ListItemText primary={s.name + " " + s.version}/>
                    </ListItem>)}
            </List>
            </div>
        </Drawer>
    )
}
